let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gcjwP")).then(() => parcelRequire('jnt25'));